import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";

import TextInput from "../../../Components/TextInput";

import { Ripple } from "primereact/ripple";
import { Image } from 'primereact/image';
import { Toast } from 'primereact/toast';
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { confirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import { Skeleton } from 'primereact/skeleton';

import { useAppDispatch, useAppSelector } from "../../../Controllers/hooks";
import { ClientProject } from "../../../Controllers/Types/ClientProjectInterface";
import { checkEmail, checkFileImage, checkPhoneNumber, checkText } from "../../../Utils/Validator";
import { comClientProjectUpdateAPI, contactDeleteAPI, createCommercialClientComanyAPI, deleteCommercialClientProjectAPI, employeePersonalUpdateAPI, employeeRoleUpdateAPI, roleDataGetAPI } from "../../../Api/ContactApi";
import { fetchAllContactAfterEditClientDetails, fetchContactSuccessAfterDeleteProjectComClient } from "../../../Controllers/Thunks/contactThunks";
import { setClientProjectStatus, setSelectedComClientProject } from "../../../Controllers/Slices/contactSlice";
import { mapRoles, Role } from "../../../Controllers/Types/UserRoleInterface";
import { imageFileExtension } from "../../../Api/FileConstant";
import { goToTop } from "../../../Components/goToTop";
import { useSelector } from "react-redux";
import { RootState } from "../../../Controllers/Store";
import { hasPermission } from "../../../Controllers/Selectors/permissionsSelector";
import ErrorPage from "../../../Components/ErrorPage";
import EmailSearchDialog from "../EmailSearchDialog";
import DataListModalInput from "../../../Components/DataListModal/DataListModalInput";
import RoleSelectionModal from "../../../Components/RoleSelectionModal";

const ViewCommercialClientContact: React.FC = () => {
    const selectedComClient = useAppSelector(state => state.contact.selectedComClient);
    const selectedProject = useAppSelector(state => state.contact.selectedClientProject);
    const clientProjectStatus = useAppSelector(state => state.contact.clientProjectStatus);
    const dispatch = useAppDispatch()

    const navigate = useNavigate();
    const toast = useRef<Toast>(null);
    const [tab, setTab] = useState<'personal' | 'project' | 'role'>('personal');
    const [showError, setShowError] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [showAddData, setShowAddData] = useState<boolean>(false);
    //const [selectedProject, setSelectedProject] = useState<ClientProject | null>(null);
    const [contentLoading, setContentLoading] = useState<boolean>(false);

    const [showProjectModal, setShowProjectModal] = useState<boolean>(false);
    const [showEditModal, setShowEditModal] = useState<boolean>(false);

    const [projects, setProjects] = useState<ClientProject[]>([]);
    const sampleImage = 'https://mdbcdn.b-cdn.net/img/new/avatars/25.webp';


    /******************************** Personal form variables ********************************/
    const [profileImage, setProfileImage] = useState<string | null>(sampleImage);
    const [imageFile, setImageFile] = useState<File | null>(null);
    const [firstName, setFirstName] = useState<string>('');
    const [lastName, setLastName] = useState<string>('');
    const [email, setEmail] = useState<string>('');
    const [mobile, setMobile] = useState<string>('');
    const [landline, setLandline] = useState<string>('');
    const [address, setAddress] = useState<string>('');
    const [city, setCity] = useState<string>('');
    const [postCode, setPostCode] = useState<string>('');

    /********************************** Personal form errors *********************************/
    const [firstNameError, setFirstNameError] = useState<string>('');
    const [lastNameError, setLastNameError] = useState<string>('');
    const [emailError, setEmailError] = useState<string>('');
    const [mobileError, setMobileError] = useState<string>('');
    const [landlineError, setLandlineError] = useState<string>('');
    const [addressError, setAddressError] = useState<string>('');
    const [cityError, setCityError] = useState<string>('');
    const [postCodeError, setPostCodeError] = useState<string>('');
    const [errorProfileImageFile, setErrorProfileImageFile] = useState<string>('');


    /******************************** Project form variables  ********************************/
    const [projectName, setProjectName] = useState<string>('');
    const [projectAddress, setProjectAddress] = useState<string>('');
    const [projectCity, setProjectCity] = useState<string>('');
    const [projectPostCode, setProjectPostCode] = useState<string>('');

    const [companyName, setCompanyName] = useState<string>('');
    const [companyRegNo, setCompanyRegNo] = useState<string>('');
    const [companyEmail, setCompanyEmail] = useState<string>('');
    const [companyMobile, setCompanyMobile] = useState<string>('');
    const [companyLandline, setCompanyLandline] = useState<string>('');
    const [companyAddress, setCompanyAddress] = useState<string>('');
    const [companyCity, setCompanyCity] = useState<string>('');
    const [companyPostCode, setCompanyPostCode] = useState<string>('');


    /****************************** Project error ********************************************/
    const [projectNameError, setProjectNameError] = useState<string>('');
    const [projectAddressError, setProjectAddressError] = useState<string>('');
    const [projectCityError, setProjectCityError] = useState<string>('');
    const [projectPostCodeError, setProjectPostCodeError] = useState<string>('');

    const [companyNameError, setCompanyNameError] = useState<string>('');
    const [companyRegNoError, setCompanyRegNoError] = useState<string>('');
    const [companyEmailError, setCompanyEmailError] = useState<string>('');
    const [companyMobileError, setCompanyMobileError] = useState<string>('');
    const [companyLandlineError, setCompanyLandlineError] = useState<string>('');
    const [companyAddressError, setCompanyAddressError] = useState<string>('');
    const [companyCityError, setCompanyCityError] = useState<string>('');
    const [companyPostCodeError, setCompanyPostCodeError] = useState<string>('');


    /********************************  Role form variables  ********************************/
    const [roleList, setRoleList] = useState<Role[]>([]);
    const [selectedRole, setSelectedRole] = useState<Role | null>(null);

    const [addRoleName, setAddRoleName] = useState<string>('');
    const [addRoleNameError, setAddRoleNameError] = useState<string>('');

    const [selectedRoleError, setSelectedRoleError] = useState<string>('');


    const [displayRoleName, setDisplayRoleName] = useState<string>('');
    const [displayRoleNameError, setDisplayRoleNameError] = useState<string>('');
    const [displayRoleCommonError, setDisplayRoleCommonError] = useState<string>('');

    /********************************Add new Project form variables  ********************************/
    const [projectNameNew, setProjectNameNew] = useState<string>('');
    const [projectAddressNew, setProjectAddressNew] = useState<string>('');
    const [projectCityNew, setProjectCityNew] = useState<string>('');
    const [projectPostCodeNew, setProjectPostCodeNew] = useState<string>('');

    const [companyNameNew, setCompanyNameNew] = useState<string>('');
    const [companyRegNoNew, setCompanyRegNoNew] = useState<string>('');
    const [companyEmailNew, setCompanyEmailNew] = useState<string>('');
    const [companyMobileNew, setCompanyMobileNew] = useState<string>('');
    const [companyLandlineNew, setCompanyLandlineNew] = useState<string>('');
    const [companyAddressNew, setCompanyAddressNew] = useState<string>('');
    const [companyCityNew, setCompanyCityNew] = useState<string>('');
    const [companyPostCodeNew, setCompanyPostCodeNew] = useState<string>('');


    /******************************Add new Project error ********************************************/
    const [projectNameErrorNew, setProjectNameErrorNew] = useState<string>('');
    const [projectAddressErrorNew, setProjectAddressErrorNew] = useState<string>('');
    const [projectCityErrorNew, setProjectCityErrorNew] = useState<string>('');
    const [projectPostCodeErrorNew, setProjectPostCodeErrorNew] = useState<string>('');

    const [companyNameErrorNew, setCompanyNameErrorNew] = useState<string>('');
    const [companyRegNoErrorNew, setCompanyRegNoErrorNew] = useState<string>('');
    const [companyEmailErrorNew, setCompanyEmailErrorNew] = useState<string>('');
    const [companyMobileErrorNew, setCompanyMobileErrorNew] = useState<string>('');
    const [companyLandlineErrorNew, setCompanyLandlineErrorNew] = useState<string>('');
    const [companyAddressErrorNew, setCompanyAddressErrorNew] = useState<string>('');
    const [companyCityErrorNew, setCompanyCityErrorNew] = useState<string>('');
    const [companyPostCodeErrorNew, setCompanyPostCodeErrorNew] = useState<string>('');

    const [showSearchComClientEmailModal, setShowSearchComClientEmailModal] = useState<boolean>(false);


    const useCanEdit = (screen: string, permission: string) => {
        return useSelector((state: RootState) => hasPermission(state, screen, permission));
    };

    const isPermissionAdd = useCanEdit('Contact', 'add')
    const isPermissionUpdate = useCanEdit('Contact', 'update')
    const isPermissionDelete = useCanEdit('Contact', 'delete')

    const [isDefaultProfileImage, setIsDefaultProfileImage] = useState<boolean>(false);


    //For image upload/change
    const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files[0]) {
            const reader = new FileReader();
            reader.onload = (event: ProgressEvent<FileReader>) => {
                if (event.target && typeof event.target.result === 'string') {
                    setProfileImage(event.target.result);
                    const file = e.target.files?.[0];
                    setImageFile(file!);
                }
            };
            reader.readAsDataURL(e.target.files[0]);
        }
    };
    // 

    // For clear image
    const clearImage = () => {
        setProfileImage(null);
        setImageFile(null);
    };
    // 


    function checkCredentials(): boolean {
        const isFirstNameValid = checkText(firstName, true, setFirstNameError)
        const isLastNameValid = checkText(lastName, true, setLastNameError)
        const isEmailValid = checkEmail(email, true, setEmailError)
        const isMobileValid = checkPhoneNumber(mobile, true, setMobileError)
        const isLandlineValid = checkPhoneNumber(landline, false, setLandlineError)
        const isAddressValid = checkText(address, true, setAddressError)
        const isCityValid = checkText(city, true, setCityError)
        const isPostCodeValid = checkText(postCode, true, setPostCodeError)
        const isFileValid = checkFileImage(imageFile!, false, setErrorProfileImageFile);

        return isFirstNameValid && isLastNameValid && isEmailValid && isMobileValid && isAddressValid && isCityValid && isPostCodeValid && isLandlineValid && isFileValid;
    }

    function showAPIErrorPersonalData(keyName: string, error: string): void {

        if (keyName === "email") {
            setEmailError(error);
        }
        if (keyName === "mobile") {
            setMobileError(error);
        }
        if (keyName === "landline") {
            setLandlineError(error);
        }
        if (keyName === "profile_image") {
            setErrorProfileImageFile(error);
        }
    }

    function clearAllErrorMassage() {
        setEmailError('');
        setMobileError('');
        setLandlineError('');
        setCompanyEmailError('');
        setCompanyMobileError('');
        setCompanyRegNoError('');
        setDisplayRoleCommonError('');
        setErrorProfileImageFile('');

    }

    /********************************  For Personal Details  ********************************/
    const handleUpdatePersonalDetails = async (e: React.FormEvent) => {
        e.preventDefault();

        clearAllErrorMassage();

        if (checkCredentials()) {
            setLoading(true)
            const res = await employeePersonalUpdateAPI(selectedComClient!.id, firstName, lastName, email, mobile, landline, address, city, postCode, imageFile!);
            setLoading(false)
            if (res.status) {

                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Personal details updated successfully.',
                        life: 3000
                    });
                }

                dispatch(fetchAllContactAfterEditClientDetails());

                setShowEditModal(false);
                clearImage();

            } else {
                if (res.statusCode === 422) {
                    Object.entries(res.errors ?? []).map(([key, value], index) => (
                        showAPIErrorPersonalData(key, value[0])
                    ))
                }
            }

        }
    }
    /**********************************************************************************************/
    function checkCredentialsProject(): boolean {
        const isProjectNameValid = checkText(projectName, true, setProjectNameError);
        const isProjectAddressValid = checkText(projectAddress, true, setProjectAddressError);
        const isProjectCityValid = checkText(projectCity, true, setProjectCityError);
        const isProjectPostCodeValid = checkText(projectPostCode, true, setProjectPostCodeError);
        const isCompanyNameValid = checkText(companyName, false, setCompanyNameError);
        const isCompanyRegNoValid = checkText(companyRegNo, false, setCompanyRegNoError);
        const isCompanyEmailValid = checkEmail(companyEmail, false, setCompanyEmailError);
        const isCompanyMobileValid = checkPhoneNumber(companyMobile, false, setCompanyMobileError);
        const isCompanyLandlineValid = checkPhoneNumber(companyLandline, false, setCompanyLandlineError);
        const isCompanyAddressValid = checkText(companyAddress, false, setCompanyAddressError);
        const isCompanyCityValid = checkText(companyCity, false, setCompanyCityError);
        const isCompanyPostCodeValid = checkText(companyPostCode, false, setCompanyPostCodeError);

        return isProjectNameValid && isProjectAddressValid && isProjectCityValid && isProjectPostCodeValid && isCompanyNameValid && isCompanyRegNoValid && isCompanyEmailValid
            && isCompanyMobileValid && isCompanyLandlineValid && isCompanyAddressValid && isCompanyCityValid && isCompanyPostCodeValid;
    }

    function showAPIErrorCompanyData(keyName: string, error: string): void {

        if (keyName === "company_email") {
            setCompanyEmailError(error);
        }
        if (keyName === "company_phone") {
            setCompanyMobileError(error);
        }
        if (keyName === "company_regno") {
            setCompanyRegNoError(error);
        }
    }


    /********************************  For Project Details  ********************************/
    const handleUpdateProjectDetails = async (e: React.FormEvent) => {
        e.preventDefault();

        clearAllErrorMassage();

        if (checkCredentialsProject()) {
            setLoading(true);
            const data = await comClientProjectUpdateAPI(selectedProject?.id!, projectName, projectAddress, projectCity, projectPostCode,
                companyName, companyRegNo, companyEmail, companyMobile, companyAddress,
                companyCity, companyPostCode);

            setLoading(false);

            if (!data.status) { // false
                if (data.statusCode === 422) {
                    Object.entries(data.errors ?? []).map(([key, value], index) => (
                        showAPIErrorCompanyData(key, value[0])
                    ))
                }
            } else {

                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Project details updated successfully.',
                        life: 3000
                    });
                }

                dispatch(setClientProjectStatus(1));
                dispatch(fetchAllContactAfterEditClientDetails());

                setShowEditModal(false);

            }

        }
    }

    const handleSelectProject = (project: ClientProject) => {
        //setContentLoading(true);
        dispatch(setSelectedComClientProject(project))
        dispatch(setClientProjectStatus(1));

        /*setTimeout(() => {
            setContentLoading(false);
        }, 400);*/
    };

    const addProject = async (e: React.FormEvent) => {
        e.preventDefault();

        setShowProjectModal(true);

        // Clear form field data
        setProjectName('');
        setProjectAddress('');
        setProjectCity('');
        setProjectPostCode('');

        setCompanyName('');
        setCompanyRegNo('');
        setCompanyEmail('');
        setCompanyMobile('');
        setCompanyLandline('');
        setCompanyAddress('');
        setCompanyCity('');
        setCompanyPostCode('');
    };

    /******************************* ADD NEW PROJECT ************************************ */
    function checkCredentialsNewProject(): boolean {
        const isProjectNameValid = checkText(projectNameNew, true, setProjectNameErrorNew);
        const isProjectAddressValid = checkText(projectAddressNew, true, setProjectAddressErrorNew);
        const isProjectCityValid = checkText(projectCityNew, true, setProjectCityErrorNew);
        const isProjectPostCodeValid = checkText(projectPostCodeNew, true, setProjectPostCodeErrorNew);
        const isCompanyNameValid = checkText(companyNameNew, false, setCompanyNameErrorNew);
        const isCompanyRegNoValid = checkText(companyRegNoNew, false, setCompanyRegNoErrorNew);
        const isCompanyEmailValid = checkEmail(companyEmailNew, false, setCompanyEmailErrorNew);
        const isCompanyMobileValid = checkPhoneNumber(companyMobileNew, false, setCompanyMobileErrorNew);
        const isCompanyLandlineValid = checkPhoneNumber(companyLandlineNew, false, setCompanyLandlineErrorNew);
        const isCompanyAddressValid = checkText(companyAddressNew, false, setCompanyAddressErrorNew);
        const isCompanyCityValid = checkText(companyCityNew, false, setCompanyCityErrorNew);
        const isCompanyPostCodeValid = checkText(companyPostCodeNew, false, setCompanyPostCodeErrorNew);

        return isProjectNameValid && isProjectAddressValid && isProjectCityValid && isProjectPostCodeValid && isCompanyNameValid && isCompanyRegNoValid && isCompanyEmailValid
            && isCompanyMobileValid && isCompanyLandlineValid && isCompanyAddressValid && isCompanyCityValid && isCompanyPostCodeValid;
    }

    function showAPIErrorCompanyDataNew(keyName: string, error: string): void {

        if (keyName === "company_email") {
            setCompanyEmailErrorNew(error);
        }
        if (keyName === "company_phone") {
            setCompanyMobileErrorNew(error);
        }
        if (keyName === "company_regno") {
            setCompanyRegNoErrorNew(error);
        }
    }

    function clearAddNewProjetFields() {
        setProjectNameNew('')
        setProjectAddressNew('')
        setProjectCityNew('')
        setProjectPostCodeNew('')
        setCompanyNameNew('')
        setCompanyRegNoNew('')
        setCompanyEmailNew('')
        setCompanyMobileNew('')
        setCompanyLandlineNew('')
        setCompanyAddressNew('')
        setCompanyCityNew('')
        setCompanyPostCodeNew('')

    }


    const handleCreateProject = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsNewProject()) {
            setLoading(true);
            const data = await createCommercialClientComanyAPI(selectedComClient?.contactId!, projectNameNew, projectAddressNew, projectCityNew, projectPostCodeNew,
                companyNameNew, companyRegNoNew, companyEmailNew, companyMobileNew, companyAddressNew,
                companyCityNew, companyPostCodeNew);

            setLoading(false);

            if (!data.status) { // false
                if (data.statusCode === 422) {
                    Object.entries(data.errors ?? []).map(([key, value], index) => (
                        showAPIErrorCompanyDataNew(key, value[0])
                    ))
                }
            } else {

                clearAddNewProjetFields()

                dispatch(fetchAllContactAfterEditClientDetails())

                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Project created successfully.',
                        life: 3000
                    });
                }

                setTimeout(() => {
                    setShowProjectModal(false);
                }, 500);


                goToTop();

            }

        }

    };
    /**********************************************************************************************/

    function checkCredentialsRole(): boolean {

        let isSelectedRoleValid: boolean = false

        if (selectedRole) {
            isSelectedRoleValid = true;
            setSelectedRoleError('')
        } else {
            setSelectedRoleError('This field is required.')
        }

        const isDisplayRoleNameValid = checkText(displayRoleName, true, setDisplayRoleNameError)


        return isSelectedRoleValid && isDisplayRoleNameValid;
    }


    /********************************  For Role Details  ********************************/
    const handleUpdateRoleDetails = async (e: React.FormEvent) => {
        e.preventDefault();

        clearAllErrorMassage();

        if (checkCredentialsRole()) {
            setLoading(true);
            const res = await employeeRoleUpdateAPI(selectedComClient!.user_role_info_id, selectedRole!.id, displayRoleName);
            setLoading(false);

            if (res.status) {

                dispatch(fetchAllContactAfterEditClientDetails());

                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Role details updated successfully.',
                        life: 3000
                    });
                }

                setTimeout(() => {
                    setShowEditModal(false);
                }, 500);

            } else {
                if (res.statusCode === 422) {
                    Object.entries(res.errors ?? []).map(([key, value], index) => (
                        setDisplayRoleCommonError(value[0])
                    ))
                }
            }
        }
    }

    const roleDataGet = async () => {
        const data = await roleDataGetAPI(localStorage.getItem('token') || '');
        if (data.status) {
            setRoleList(mapRoles(data.data || []) || []);
        }
    }

    function checkCredentialsRoleCreate(roleName: string): boolean {
        const isRoleNameValid = checkText(roleName, true, setAddRoleNameError);
        return isRoleNameValid;
    }

    // For create custom role


    const [showRoleSelectionModal, setShowRoleSelectionModal] = useState<boolean>(false);

    const handleShowRoleModal = () => {
        setShowRoleSelectionModal(true);
    }

    const handleCloseRoleModal = () => {
        setShowRoleSelectionModal(false);
    }


    /**********************************************************************************************/


    /********************************  for Delete contact  ********************************/
    const handleDeleteContact = async (e: React.FormEvent) => {
        confirmDialog({
            message: 'Are you sure you want to delete the commercial client details?',
            header: 'Confirm the deletion',
            icon: 'bi bi-info-circle',
            defaultFocus: 'accept',
            acceptClassName: 'p-button-danger',
            accept: deleteContact,
        });
    };

    const deleteContact = async () => {
        const res = await contactDeleteAPI(selectedComClient!.contactId);

        if (res.status) {

            if (toast.current) {
                toast.current.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Commercial Client deleted successfully.',
                    life: 3000
                });
            }

            setShowEditModal(false);

            setTimeout(() => {
                goBack()
            }, 500);



        } else {
            if (res.statusCode === 422) {
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Failed',
                        detail: 'Commercial Client deleted failed.',
                        life: 3000
                    });
                }
            }
        }
    }


    const handleDeleteProjectContact = (projectId: number): void => {
        confirmDialog({
            message: 'Are you sure you want to delete the project details?',
            header: 'Confirm the deletion',
            icon: 'bi bi-info-circle',
            defaultFocus: 'accept',
            acceptClassName: 'p-button-danger',
            accept: () => deleteProjectContact(projectId),
        });
    }

    const deleteProjectContact = async (projectId: number) => {

        const res = await deleteCommercialClientProjectAPI(projectId);

        if (res.status) {

            dispatch(fetchContactSuccessAfterDeleteProjectComClient())

            if (toast.current) {
                toast.current.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Project deleted successfully.',
                    life: 3000
                });
            }





        } else {
            if (res.statusCode === 422) {

                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Failed',
                        detail: 'Project deleted failed.',
                        life: 3000
                    });
                }
            }
        }

    }
    /**********************************************************************************************/


    const switchTabs = (tab: 'personal' | 'project' | 'role') => {
        setTab(tab);
        dispatch(setClientProjectStatus(0));
    };

    const goBack = () => {
        navigate(-1);
        goToTop();
    }

    const [minHeight, setMinHeight] = useState<string>('0px');

    const calculateMinHeight = () => {
        const windowHeight = window.innerHeight;
        const distanceFromBottom = 200;
        const calculatedHeight = windowHeight - distanceFromBottom;
        setMinHeight(`${calculatedHeight}px`);
    };

    const toggleAddData = () => {
        setShowAddData(!showAddData);
    };

    useEffect(() => {
        roleDataGet();
        calculateMinHeight();
        window.addEventListener('resize', calculateMinHeight);

        return () => {
            window.removeEventListener('resize', calculateMinHeight);
        };
    }, []);

    /* Project modal component */
    const projectModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                Add Project
            </h5>
            <button type="button" className="close_modal_btn p-ripple"
                onClick={() => setShowProjectModal(false)}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    );

    const projectModalFooter = (
        <div className="custom_modal_footer">
            <Button label="Close" className="custom_btn secondary" onClick={() => setShowProjectModal(false)} />
            <Button label={`${loading ? 'Processing' : 'Save'}`} onClick={handleCreateProject} loading={loading} className="custom_btn primary" />
        </div>
    );
    /* */

    /* Edit modal component */
    const editModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                {tab === 'personal' ?
                    "Edit Personal detail" :
                    tab === 'project' ?
                        "Edit Project detail" :
                        tab === 'role' ?
                            "Edit Role detail" :
                            null
                }
            </h5>
            {isPermissionDelete && <button type="button" className="data_delete_btn p-ripple"
                onClick={handleDeleteContact}>
                <i className="bi bi-trash3"></i>
                <Ripple />
            </button>}
        </div>
    );

    const editModalFooter = (
        <div className="custom_modal_footer">
            <Button label="Close" className="custom_btn secondary" onClick={() => setShowEditModal(false)} />
            {tab === 'personal' ? (
                <Button label={`${loading ? 'Updating' : 'Update'}`} onClick={handleUpdatePersonalDetails} loading={loading} className="custom_btn primary" />
            ) : tab === 'project' ? (
                <Button label={`${loading ? 'Updating' : 'Update'}`} onClick={handleUpdateProjectDetails} loading={loading} className="custom_btn primary" />
            ) : tab === 'role' ? (
                <Button label={`${loading ? 'Updating' : 'Update'}`} onClick={handleUpdateRoleDetails} loading={loading} className="custom_btn primary" />
            ) : null
            }
        </div>
    );
    /* */

    useEffect(() => {
        setFirstName(selectedComClient?.first_name!)
        setProfileImage(selectedComClient?.profile_image!)
        setLastName(selectedComClient?.last_name!)
        setEmail(selectedComClient?.email!)
        setMobile(selectedComClient?.mobile!)
        //setLandline(comClient?.landline!)
        setAddress(selectedComClient?.address!)
        setCity(selectedComClient?.city!)
        setPostCode(selectedComClient?.post_code!)
        setProjects(selectedComClient?.projects!);

        if (clientProjectStatus === 0) {
            if (selectedComClient?.projects) {
                const project = selectedComClient?.projects![0];
                dispatch(setSelectedComClientProject(project))
            }
        } else {
            dispatch(setSelectedComClientProject(selectedProject!))
        }


        if (selectedComClient && selectedComClient?.profile_image) {
            const fileName = selectedComClient?.profile_image.split('/').pop();

            if (fileName === 'user.png') {
                setIsDefaultProfileImage(true);
            } else {
                setIsDefaultProfileImage(false);
            }
        } else {
            setIsDefaultProfileImage(false);
        }
    }, [selectedComClient]);

    useEffect(() => {
        setProjectName(selectedProject?.projectName!)
        setProjectAddress(selectedProject?.projectAddress!)
        setProjectCity(selectedProject?.projectCity!)
        setProjectPostCode(selectedProject?.projectPostCode!)
        setCompanyName(selectedProject?.companyName!)
        setCompanyRegNo(selectedProject?.companyRegNo!)
        setCompanyEmail(selectedProject?.email!)
        setCompanyMobile(selectedProject?.mobile!)
        setCompanyLandline(selectedProject?.landline!)
        setCompanyAddress(selectedProject?.address!)
        setCompanyCity(selectedProject?.city!)
        setCompanyPostCode(selectedProject?.postCode!)
    }, [selectedProject]);


    useEffect(() => {
        if (selectedComClient?.user_role_id !== null) {
            const contactRole = roleList?.find((role) => role?.id === selectedComClient?.user_role_id);
            setSelectedRole(contactRole!);
        }

        setDisplayRoleName(selectedComClient?.display_role_name || '')
    }, [selectedComClient, roleList]);

    useEffect(() => {
        dispatch(setClientProjectStatus(0));
    }, [dispatch])

    useEffect(() => {
        if (clientProjectStatus === 0) {
            if (selectedComClient?.projects) {
                const project = selectedComClient?.projects![0];
                dispatch(setSelectedComClientProject(project))
            }

        } else {
            dispatch(setSelectedComClientProject(selectedProject!))
        }
    }, [dispatch, clientProjectStatus, selectedComClient, selectedProject])

    const onEmailConfirmComClient = (email: string) => {
        setEmail(email);
    }

    /* Clear validation messages */
    // Personal
    useEffect(() => {
        checkText(firstName, false, setFirstNameError);
    }, [firstName]);

    useEffect(() => {
        checkText(lastName, false, setLastNameError);
    }, [lastName]);

    useEffect(() => {
        checkEmail(email, false, setEmailError);
    }, [email]);

    useEffect(() => {
        checkPhoneNumber(mobile, false, setMobileError);
    }, [mobile]);

    useEffect(() => {
        checkPhoneNumber(landline, false, setLandlineError);
    }, [landline]);

    useEffect(() => {
        checkText(address, false, setAddressError);
    }, [address]);

    useEffect(() => {
        checkText(city, false, setCityError);
    }, [city]);

    useEffect(() => {
        checkText(postCode, false, setPostCodeError);
    }, [postCode]);

    useEffect(() => {
        checkFileImage(imageFile!, false, setErrorProfileImageFile);
    }, [imageFile]);
    // 

    // Project
    useEffect(() => {
        checkText(projectName, false, setProjectNameError);
    }, [projectName]);

    useEffect(() => {
        checkText(projectAddress, false, setProjectAddressError);
    }, [projectAddress]);

    useEffect(() => {
        checkText(projectCity, false, setProjectCityError);
    }, [projectCity]);

    useEffect(() => {
        checkText(projectPostCode, false, setProjectPostCodeError);
    }, [projectPostCode]);

    useEffect(() => {
        checkText(companyName, false, setCompanyNameError);
    }, [companyName]);

    useEffect(() => {
        checkText(companyRegNo, false, setCompanyRegNoError);
    }, [companyRegNo]);

    useEffect(() => {
        checkEmail(companyEmail, false, setCompanyEmailError);
    }, [companyEmail]);

    useEffect(() => {
        checkPhoneNumber(companyMobile, false, setCompanyMobileError);
    }, [companyMobile]);

    useEffect(() => {
        checkPhoneNumber(companyLandline, false, setCompanyLandlineError);
    }, [companyLandline]);

    useEffect(() => {
        checkText(companyAddress, false, setCompanyAddressError);
    }, [companyAddress]);

    useEffect(() => {
        checkText(companyCity, false, setCompanyCityError);
    }, [companyCity]);

    useEffect(() => {
        checkText(companyPostCode, false, setCompanyPostCodeError);
    }, [companyPostCode]);
    // 

    useEffect(() => {
        checkText(projectNameNew, false, setProjectNameErrorNew);
    }, [projectNameNew]);

    useEffect(() => {
        checkText(projectAddressNew, false, setProjectAddressErrorNew);
    }, [projectAddressNew]);

    useEffect(() => {
        checkText(projectCityNew, false, setProjectCityErrorNew);
    }, [projectCityNew]);

    useEffect(() => {
        checkText(projectPostCodeNew, false, setProjectPostCodeErrorNew);
    }, [projectPostCodeNew]);

    useEffect(() => {
        checkText(companyNameNew, false, setCompanyNameErrorNew);
    }, [companyNameNew]);

    useEffect(() => {
        checkText(companyRegNoNew, false, setCompanyRegNoErrorNew);
    }, [companyRegNoNew]);

    useEffect(() => {
        checkEmail(companyEmailNew, false, setCompanyEmailErrorNew);
    }, [companyEmailNew]);

    useEffect(() => {
        checkPhoneNumber(companyMobileNew, false, setCompanyMobileErrorNew);
    }, [companyMobileNew]);

    useEffect(() => {
        checkPhoneNumber(companyLandlineNew, false, setCompanyLandlineErrorNew);
    }, [companyLandlineNew]);

    useEffect(() => {
        checkText(companyAddressNew, false, setCompanyAddressErrorNew);
    }, [companyAddressNew]);

    useEffect(() => {
        checkText(companyCityNew, false, setCompanyCityErrorNew);
    }, [companyCityNew]);

    useEffect(() => {
        checkText(companyPostCodeNew, false, setCompanyPostCodeErrorNew);
    }, [companyPostCodeNew]);
    // 

    // Role
    useEffect(() => {
        if (selectedRole !== null && selectedRole !== undefined) {
            setSelectedRoleError('');
        }
    }, [selectedRole]);

    useEffect(() => {
        checkText(displayRoleName, false, setDisplayRoleNameError);
    }, [displayRoleName]);

    useEffect(() => {
        checkText(addRoleName, false, setAddRoleNameError);
    }, [addRoleName]);
    //
    /*  */

    return (
        <React.Fragment>
            <Toast ref={toast} />

            <div className="main_content layout_padding show_side_bar">
                {(!selectedComClient) ? (
                    <ErrorPage
                        errorMessage="There was an error retrieving the selected client details."
                    />
                ) : (
                    <React.Fragment>
                        <div className="main_head_area">
                            <h4 className="main_heading">View Contact</h4>

                            <button className="back_btn p-ripple" onClick={goBack}>
                                <i className="bi bi-arrow-left me-2"></i>
                                Back
                                <Ripple />
                            </button>
                        </div>

                        <div className="page_label_area">
                            <h6>Commercial Client</h6>

                            {tab === 'project' && isPermissionAdd && (
                                <div className="page_action_area">
                                    <button className="add_data_link_btn p-ripple" onClick={addProject}>
                                        <i className="bi bi-plus-circle"></i>
                                        <span>Add project</span>
                                        <Ripple />
                                    </button>
                                </div>
                            )}
                        </div>

                        <div className="page_content mt-0">
                            <div className="page_body_area mt-3">
                                <div className="row">
                                    <div className="col-12 col-xl-4 mx-auto page_divider custom_height" style={{ minHeight }}>
                                        <div className="profile_view_area mt-2 mt-sm-0 mb-4 mb-sm-0">
                                            <div className="profile_view_main_area">
                                                <Image
                                                    className="profile_img_area"
                                                    src={selectedComClient?.profile_image}
                                                    alt="Profile"
                                                    preview={!isDefaultProfileImage}
                                                />
                                                <h5 className="profile_name text_purple">
                                                    {(selectedComClient?.first_name || selectedComClient?.last_name)
                                                        ? `${selectedComClient?.first_name ?? ''} ${selectedComClient?.last_name ?? ''}`.trim()
                                                        : ''
                                                    }
                                                </h5>
                                                <h6 className="profile_role">{selectedComClient?.contactSubType}</h6>
                                            </div>

                                            <div className="profile_view_tab_area">
                                                <div className="profile_view_tabs" id="profileViewTab" role="tablist" aria-orientation="vertical">
                                                    <button
                                                        className={`profile_view_tab_btn p-ripple ${tab === 'personal' ? 'active' : ''}`}
                                                        onClick={() => switchTabs('personal')}
                                                        id="personal-detail-tab"
                                                        data-bs-toggle="pill"
                                                        data-bs-target="#personal-detail"
                                                        type="button"
                                                        role="tab"
                                                        aria-controls="personal-detail"
                                                        aria-selected={tab === 'personal'}
                                                    >
                                                        Personal
                                                        <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                                    </button>

                                                    <button
                                                        className={`profile_view_tab_btn p-ripple ${tab === 'project' ? 'active' : ''}`}
                                                        onClick={() => switchTabs('project')}
                                                        id="project-detail-tab"
                                                        data-bs-toggle="pill"
                                                        data-bs-target="#project-detail"
                                                        type="button"
                                                        role="tab"
                                                        aria-controls="project-detail"
                                                        aria-selected={tab === 'project'}
                                                    >
                                                        Project
                                                        <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                                    </button>

                                                    <button
                                                        className={`profile_view_tab_btn p-ripple ${tab === 'role' ? 'active' : ''}`}
                                                        onClick={() => switchTabs('role')}
                                                        id="role-detail-tab"
                                                        data-bs-toggle="pill"
                                                        data-bs-target="#role-detail"
                                                        type="button"
                                                        role="tab"
                                                        aria-controls="role-detail"
                                                        aria-selected={tab === 'role'}
                                                    >
                                                        Role
                                                        <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 col-xl-8">
                                        <div className="profile_view_area">
                                            {/* Edit button */}
                                            {isPermissionUpdate && (
                                                <button className={`profile_edit_btn main ${tab === 'project' && projects.length === 0 && 'd-none'} p-ripple`}
                                                    onClick={() => setShowEditModal(true)}>
                                                    <i className="bi bi-pencil-square"></i>
                                                    <Ripple />
                                                </button>
                                            )}

                                            <div className="tab-content profile_view_tab_content" id="profileViewTabContent">
                                                {/* Personal Details */}
                                                <div className={`tab-pane profile_view_tab_panel fade ${tab === 'personal' ? 'show active' : ''}`} id="personal-detail" role="tabpanel" aria-labelledby="personal-detail-tab" tabIndex={0}>
                                                    <div className="row">
                                                        {/* First name */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">First name</label>
                                                                <div className="form_data_view_box">
                                                                    {selectedComClient?.first_name ? (
                                                                        <p>{selectedComClient?.first_name}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">First name</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Last name */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Last name</label>
                                                                <div className="form_data_view_box">
                                                                    {selectedComClient?.last_name ? (
                                                                        <p>{selectedComClient?.last_name}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">Last name</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Email */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Email</label>
                                                                <div className="form_data_view_box">
                                                                    {selectedComClient?.email ? (
                                                                        <Link
                                                                            to={`mailto:${selectedComClient?.email}`}
                                                                            className="text_no_wrap is_link is_contact_element mail">
                                                                            {selectedComClient?.email}
                                                                        </Link>
                                                                    ) : (
                                                                        <span className="placeholder_text">Email</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Mobile */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Mobile</label>
                                                                <div className="form_data_view_box">
                                                                    {selectedComClient?.mobile ? (
                                                                        <Link
                                                                            to={`tel:${selectedComClient?.mobile}`}
                                                                            className="text_no_wrap is_link is_contact_element phone">
                                                                            {selectedComClient?.mobile}
                                                                        </Link>
                                                                    ) : (
                                                                        <span className="placeholder_text">Mobile</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Landline */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Landline</label>
                                                                <div className="form_data_view_box">
                                                                    {selectedComClient?.landline ? (
                                                                        <Link
                                                                            to={`tel:${selectedComClient?.landline}`}
                                                                            className="text_no_wrap is_link is_contact_element phone">
                                                                            {selectedComClient?.landline}
                                                                        </Link>
                                                                    ) : (
                                                                        <span className="placeholder_text">Landline</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Address */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Address</label>
                                                                <div className="form_data_view_box">
                                                                    {selectedComClient?.address ? (
                                                                        <p>{selectedComClient?.address}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">Address</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* City */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">City</label>
                                                                <div className="form_data_view_box">
                                                                    {selectedComClient?.city ? (
                                                                        <p>{selectedComClient?.city}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">City</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Post code */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Post code</label>
                                                                <div className="form_data_view_box">
                                                                    {selectedComClient?.post_code ? (
                                                                        <p>{selectedComClient?.post_code}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">Post code</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Project Details */}
                                                <div className={`tab-pane profile_view_tab_panel pt-sm-0 pt-xl-4 fade ${tab === 'project' ? 'show active' : ''}`} id="project-detail" role="tabpanel" aria-labelledby="project-detail-tab" tabIndex={0}>
                                                    {projects && projects?.length > 0 ? (
                                                        <React.Fragment>
                                                            <div className="project_selection_area">
                                                                <div className="row">
                                                                    {projects.map((project) => (
                                                                        <div key={project.id} className="project_selection_container col-11 mx-auto mx-sm-0 col-xxl-4 col-xl-4 col-md-4">
                                                                            <article className={`project_selection p-ripple ${selectedProject?.id === project.id ? 'selected' : ''}`}
                                                                                onClick={() => handleSelectProject(project)}>
                                                                                <h6>{project.projectName}</h6>
                                                                                <Ripple />
                                                                            </article>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>

                                                            {selectedProject && selectedProject !== null && (
                                                                <div className="project_view_area">
                                                                    {contentLoading ? (
                                                                        <div className="content_loading_area w-100">
                                                                            <div className="row">
                                                                                <div className="col-12 col-xl-6 col-sm-6">
                                                                                    <div className="page_form_group">
                                                                                        <Skeleton className="label_loading"></Skeleton>
                                                                                        <Skeleton className="input_loding"></Skeleton>
                                                                                    </div>
                                                                                </div>

                                                                                <div className="col-12 col-xl-6 col-sm-6">
                                                                                    <div className="page_form_group">
                                                                                        <Skeleton className="label_loading"></Skeleton>
                                                                                        <Skeleton className="input_loding"></Skeleton>
                                                                                    </div>
                                                                                </div>

                                                                                <div className="col-12 col-xl-6 col-sm-6">
                                                                                    <div className="page_form_group">
                                                                                        <Skeleton className="label_loading"></Skeleton>
                                                                                        <Skeleton className="input_loding"></Skeleton>
                                                                                    </div>
                                                                                </div>

                                                                                <div className="col-12 col-xl-6 col-sm-6">
                                                                                    <div className="page_form_group">
                                                                                        <Skeleton className="label_loading"></Skeleton>
                                                                                        <Skeleton className="input_loding"></Skeleton>
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                            <hr className="mt-0 mb-4" />

                                                                            <div className="row">
                                                                                <div className="col-12 col-xl-6 col-sm-6">
                                                                                    <div className="page_form_group">
                                                                                        <Skeleton className="label_loading"></Skeleton>
                                                                                        <Skeleton className="input_loding"></Skeleton>
                                                                                    </div>
                                                                                </div>

                                                                                <div className="col-12 col-xl-6 col-sm-6">
                                                                                    <div className="page_form_group">
                                                                                        <Skeleton className="label_loading"></Skeleton>
                                                                                        <Skeleton className="input_loding"></Skeleton>
                                                                                    </div>
                                                                                </div>

                                                                                <div className="col-12 col-xl-6 col-sm-6">
                                                                                    <div className="page_form_group">
                                                                                        <Skeleton className="label_loading"></Skeleton>
                                                                                        <Skeleton className="input_loding"></Skeleton>
                                                                                    </div>
                                                                                </div>

                                                                                <div className="col-12 col-xl-6 col-sm-6">
                                                                                    <div className="page_form_group">
                                                                                        <Skeleton className="label_loading"></Skeleton>
                                                                                        <Skeleton className="input_loding"></Skeleton>
                                                                                    </div>
                                                                                </div>

                                                                                <div className="col-12 col-xl-6 col-sm-6">
                                                                                    <div className="page_form_group">
                                                                                        <Skeleton className="label_loading"></Skeleton>
                                                                                        <Skeleton className="input_loding"></Skeleton>
                                                                                    </div>
                                                                                </div>

                                                                                <div className="col-12 col-xl-6 col-sm-6">
                                                                                    <div className="page_form_group">
                                                                                        <Skeleton className="label_loading"></Skeleton>
                                                                                        <Skeleton className="input_loding"></Skeleton>
                                                                                    </div>
                                                                                </div>

                                                                                <div className="col-12 col-xl-6 col-sm-6">
                                                                                    <div className="page_form_group">
                                                                                        <Skeleton className="label_loading"></Skeleton>
                                                                                        <Skeleton className="input_loding"></Skeleton>
                                                                                    </div>
                                                                                </div>

                                                                                <div className="col-12 col-xl-6 col-sm-6">
                                                                                    <div className="page_form_group">
                                                                                        <Skeleton className="label_loading"></Skeleton>
                                                                                        <Skeleton className="input_loding"></Skeleton>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ) : (
                                                                        <div className="content_view_area w-100">
                                                                            <div className="row">
                                                                                {/* Project name */}
                                                                                <div className="col-12 col-xl-6 col-sm-6">
                                                                                    <div className="page_form_group">
                                                                                        <label className="custom_form_label">Project name</label>
                                                                                        <div className="form_data_view_box">
                                                                                            {selectedProject.projectName ? (
                                                                                                <p>{selectedProject.projectName}</p>
                                                                                            ) : (
                                                                                                <span className="placeholder_text">Project name</span>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                                {/* Address */}
                                                                                <div className="col-12 col-xl-6 col-sm-6">
                                                                                    <div className="page_form_group">
                                                                                        <label className="custom_form_label">Address</label>
                                                                                        <div className="form_data_view_box">
                                                                                            {selectedProject.projectAddress ? (
                                                                                                <p>{selectedProject.projectAddress}</p>
                                                                                            ) : (
                                                                                                <span className="placeholder_text">Address</span>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                                {/* City */}
                                                                                <div className="col-12 col-xl-6 col-sm-6">
                                                                                    <div className="page_form_group">
                                                                                        <label className="custom_form_label">City</label>
                                                                                        <div className="form_data_view_box">
                                                                                            {selectedProject.projectCity ? (
                                                                                                <p>{selectedProject.projectCity}</p>
                                                                                            ) : (
                                                                                                <span className="placeholder_text">City</span>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                                {/* Post code */}
                                                                                <div className="col-12 col-xl-6 col-sm-6">
                                                                                    <div className="page_form_group">
                                                                                        <label className="custom_form_label">Post code</label>
                                                                                        <div className="form_data_view_box">
                                                                                            {selectedProject.projectPostCode ? (
                                                                                                <p>{selectedProject.projectName}</p>
                                                                                            ) : (
                                                                                                <span className="placeholder_text">Post code</span>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                            <hr className="mt-0 mb-4" />

                                                                            <div className="row">
                                                                                {/* Company name */}
                                                                                <div className="col-12 col-xl-6 col-sm-6">
                                                                                    <div className="page_form_group">
                                                                                        <label className="custom_form_label">Company name</label>
                                                                                        <div className="form_data_view_box">
                                                                                            {selectedProject.companyName ? (
                                                                                                <p>{selectedProject.companyName}</p>
                                                                                            ) : (
                                                                                                <span className="placeholder_text">Company name</span>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                                {/* Reg No. */}
                                                                                <div className="col-12 col-xl-6 col-sm-6">
                                                                                    <div className="page_form_group">
                                                                                        <label className="custom_form_label">Reg No.</label>
                                                                                        <div className="form_data_view_box">
                                                                                            {selectedProject.companyRegNo ? (
                                                                                                <p>{selectedProject.companyRegNo}</p>
                                                                                            ) : (
                                                                                                <span className="placeholder_text">Reg No.</span>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                                {/* Company Email id */}
                                                                                <div className="col-12 col-xl-6 col-sm-6">
                                                                                    <div className="page_form_group">
                                                                                        <label className="custom_form_label">Company Email</label>
                                                                                        <div className="form_data_view_box">
                                                                                            {selectedProject.email ? (
                                                                                                <Link
                                                                                                    to={`mailto:${selectedProject.email}`}
                                                                                                    className="text_no_wrap is_link is_contact_element mail">
                                                                                                    {selectedProject.email}
                                                                                                </Link>
                                                                                            ) : (
                                                                                                <span className="placeholder_text">Company Email</span>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                                {/* Mobile */}
                                                                                <div className="col-12 col-xl-6 col-sm-6">
                                                                                    <div className="page_form_group">
                                                                                        <label className="custom_form_label">Mobile</label>
                                                                                        <div className="form_data_view_box">
                                                                                            {selectedProject.mobile ? (
                                                                                                <Link
                                                                                                    to={`tel:${selectedProject.mobile}`}
                                                                                                    className="text_no_wrap is_link is_contact_element phone">
                                                                                                    {selectedProject.mobile}
                                                                                                </Link>
                                                                                            ) : (
                                                                                                <span className="placeholder_text">Mobile</span>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                                {/* Landline */}
                                                                                <div className="col-12 col-xl-6 col-sm-6">
                                                                                    <div className="page_form_group">
                                                                                        <label className="custom_form_label">Landline</label>
                                                                                        <div className="form_data_view_box">
                                                                                            {selectedProject.landline ? (
                                                                                                <Link
                                                                                                    to={`tel:${selectedProject.landline}`}
                                                                                                    className="text_no_wrap is_link is_contact_element phone">
                                                                                                    {selectedProject.landline}
                                                                                                </Link>
                                                                                            ) : (
                                                                                                <span className="placeholder_text">Landline</span>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                                {/* Company address */}
                                                                                <div className="col-12 col-xl-6 col-sm-6">
                                                                                    <div className="page_form_group">
                                                                                        <label className="custom_form_label">Company address</label>
                                                                                        <div className="form_data_view_box">
                                                                                            {selectedProject.address ? (
                                                                                                <p>{selectedProject.address}</p>
                                                                                            ) : (
                                                                                                <span className="placeholder_text">Company address</span>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                                {/* City */}
                                                                                <div className="col-12 col-xl-6 col-sm-6">
                                                                                    <div className="page_form_group">
                                                                                        <label className="custom_form_label">City</label>
                                                                                        <div className="form_data_view_box">
                                                                                            {selectedProject.city ? (
                                                                                                <p>{selectedProject.city}</p>
                                                                                            ) : (
                                                                                                <span className="placeholder_text">City</span>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                                {/* Post code */}
                                                                                <div className="col-12 col-xl-6 col-sm-6">
                                                                                    <div className="page_form_group">
                                                                                        <label className="custom_form_label">Post code</label>
                                                                                        <div className="form_data_view_box">
                                                                                            {selectedProject.postCode ? (
                                                                                                <p>{selectedProject.postCode}</p>
                                                                                            ) : (
                                                                                                <span className="placeholder_text">Post code</span>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </React.Fragment>
                                                    ) : (
                                                        <div className="contact_no_data">
                                                            <img src="/assets/images/no_data/no_project.png" alt="" />
                                                            <h6>No project data found! Click the Add button to add the project</h6>
                                                        </div>
                                                    )}
                                                </div>

                                                {/* Role Details */}
                                                <div className={`tab-pane profile_view_tab_panel fade ${tab === 'role' ? 'show active' : ''}`} id="role-detail" role="tabpanel" aria-labelledby="role-detail-tab" tabIndex={0}>
                                                    <div className="row">
                                                        {/* Role Name */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Role Name</label>
                                                                <div className="form_data_view_box">
                                                                    {selectedComClient?.role_name ? (
                                                                        <p>{selectedComClient?.role_name}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">Role Name</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Display Role Name */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Display Role Name</label>
                                                                <div className="form_data_view_box">
                                                                    {selectedComClient?.display_role_name ? (
                                                                        <p>{selectedComClient?.display_role_name}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">Display Role Name</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                )}

                {/* Contact edit modal */}
                <Dialog header={editModalHeader} headerClassName="custom_modal_header"
                    footer={editModalFooter} visible={showEditModal}
                    className="custom_modal_dialog modal_dialog_lg" onHide={() => { if (!showEditModal) return; setShowEditModal(false); }}>
                    <div className="custom_modal_body custom">
                        <div className="row">
                            <div className="col-12 col-xl-4 page_divider">
                                <div className="profile_edit_area">
                                    {tab === 'personal' ? (
                                        <React.Fragment>
                                            <div className="form_img_upload_area pt-0">
                                                <div className="form_img_upload">
                                                    <input
                                                        type="file"
                                                        accept={imageFileExtension}
                                                        className="form_img_upload_input"
                                                        id="profileImage"
                                                        onChange={handleImageChange}
                                                    />
                                                    <div className="form_img_upload_label_area">
                                                        <label
                                                            htmlFor="profileImage"
                                                            className={`form_img_upload_label ${profileImage ? 'uploaded' : ''}`}
                                                            style={{ backgroundImage: profileImage ? `url(${profileImage})` : selectedComClient?.profile_image ? `url(${selectedComClient?.profile_image})` : '' }}
                                                        >
                                                            {(!profileImage && selectedComClient?.profile_image === null) && (
                                                                <div className="upload_icon">
                                                                    <i className="bi bi-camera-fill"></i>
                                                                </div>
                                                            )}
                                                        </label>

                                                        {(profileImage || selectedComClient?.profile_image) && (
                                                            <label htmlFor="profileImage" className="upload_update_icon">
                                                                <i className="bi bi-camera-fill"></i>
                                                            </label>
                                                        )}
                                                    </div>
                                                    {profileImage ? (
                                                        <React.Fragment>
                                                            <label htmlFor="profileImage" className="add_image_label mt-2">Change image</label>
                                                            {imageFile && (
                                                                <button className="upload_clear_button mt-2" onClick={clearImage}>Remove</button>
                                                            )}
                                                        </React.Fragment>
                                                    ) : selectedComClient?.profile_image ? (
                                                        <label htmlFor="profileImage" className="add_image_label mt-2">Change image</label>
                                                    ) : (
                                                        <label htmlFor="profileImage" className="add_image_label mt-2">Add image</label>
                                                    )}
                                                </div>
                                            </div>

                                            {errorProfileImageFile !== '' && (
                                                <small className="form_error_msg text-center mt-2">{errorProfileImageFile}</small>
                                            )}
                                        </React.Fragment>
                                    ) : (
                                        <div className="profile_view_main_area mb-4">
                                            <Image
                                                className="profile_img_area custom"
                                                src={selectedComClient?.profile_image ?? ''}
                                                alt="Profile"
                                                preview={!isDefaultProfileImage}
                                            />

                                            <h5 className="profile_name text_purple">
                                                {(selectedComClient?.first_name || selectedComClient?.last_name)
                                                    ? `${selectedComClient?.first_name ?? ''} ${selectedComClient?.last_name ?? ''}`.trim()
                                                    : ''
                                                }
                                            </h5>
                                            <h6 className="profile_role">{selectedComClient?.role_name}</h6>
                                        </div>
                                    )}

                                    <div className="profile_edit_tab_area">
                                        <div className="profile_view_tabs" id="profileEditTab" role="tablist" aria-orientation="vertical">
                                            <button
                                                className={`profile_view_tab_btn p-ripple ${tab === 'personal' ? 'active' : ''}`}
                                                onClick={() => switchTabs('personal')}
                                                id="personal-edit-detail-tab"
                                                data-bs-toggle="pill"
                                                data-bs-target="#personal-edit-detail"
                                                type="button"
                                                role="tab"
                                                aria-controls="personal-edit-detail"
                                                aria-selected={tab === 'personal'}
                                            >
                                                Personal
                                                <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                            </button>

                                            <button
                                                className={`profile_view_tab_btn p-ripple ${tab === 'project' ? 'active' : ''}`}
                                                onClick={() => switchTabs('project')}
                                                id="project-edit-detail-tab"
                                                data-bs-toggle="pill"
                                                data-bs-target="#project-edit-detail"
                                                type="button"
                                                role="tab"
                                                aria-controls="project-edit-detail"
                                                aria-selected={tab === 'project'}
                                            >
                                                Project
                                                <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                            </button>

                                            <button
                                                className={`profile_view_tab_btn p-ripple ${tab === 'role' ? 'active' : ''}`}
                                                onClick={() => switchTabs('role')}
                                                id="role-edit-detail-tab"
                                                data-bs-toggle="pill"
                                                data-bs-target="#role-edit-detail"
                                                type="button"
                                                role="tab"
                                                aria-controls="role-edit-detail"
                                                aria-selected={tab === 'role'}
                                            >
                                                Role
                                                <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 col-xl-8">
                                <div className="profile_edit_area edit_form h-100">
                                    <div className="tab-content profile_view_tab_content" id="profileEditTabContent">
                                        {/* Edit Personal detail */}
                                        <div className={`tab-pane profile_view_tab_panel p-0 fade ${tab === 'personal' ? 'show active' : ''}`}
                                            id="personal-edit-detail" role="tabpanel" aria-labelledby="personal-edit-detail-tab" tabIndex={0}>
                                            <div className="row">
                                                {/* First name */}
                                                <div className="col-12 col-xl-6 col-sm-6">
                                                    <TextInput
                                                        id="firstName"
                                                        label="First name"
                                                        labelHtmlFor="firstName"
                                                        required={true}
                                                        value={firstName}
                                                        placeholder="First name"
                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFirstName(e.target.value)}
                                                        error={firstNameError}
                                                    />
                                                </div>

                                                {/* Last name */}
                                                <div className="col-12 col-xl-6 col-sm-6">
                                                    <TextInput
                                                        id="lastName"
                                                        label="Last name"
                                                        labelHtmlFor="lastName"
                                                        required={true}
                                                        value={lastName}
                                                        placeholder="Last name"
                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setLastName(e.target.value)}
                                                        error={lastNameError}
                                                    />
                                                </div>

                                                {/* Email */}
                                                <div className="col-12 col-xl-6 col-sm-6">
                                                    <div className="page_form_group">
                                                        <label htmlFor="email" className="custom_form_label is_required">Email</label>

                                                        <div className="input_search_group">
                                                            <InputText
                                                                id="email"
                                                                value={email}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="Email"
                                                                disabled
                                                            />

                                                            {!email ? (
                                                                <button
                                                                    className="input_grp_btn primary pos_abs p-ripple"
                                                                    onClick={() => setShowSearchComClientEmailModal(true)}>
                                                                    <i className="bi bi-search"></i>
                                                                    <Ripple />
                                                                </button>
                                                            ) : (
                                                                <button
                                                                    className="input_grp_btn danger pos_abs p-ripple"
                                                                    onClick={() => setEmail('')}>
                                                                    <i className="bi bi-x-lg"></i>
                                                                    <Ripple />
                                                                </button>
                                                            )}
                                                        </div>
                                                        {emailError &&
                                                            <small className="form_error_msg">{emailError}</small>
                                                        }
                                                    </div>
                                                </div>

                                                {/* Mobile */}
                                                <div className="col-12 col-xl-6 col-sm-6">
                                                    <TextInput
                                                        id="mobile"
                                                        label="Mobile"
                                                        labelHtmlFor="mobile"
                                                        required={true}
                                                        value={mobile}
                                                        placeholder="Mobile"
                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setMobile(e.target.value)}
                                                        error={mobileError}
                                                    />
                                                </div>

                                                {/* Landline */}
                                                <div className="col-12 col-xl-6 col-sm-6">
                                                    <TextInput
                                                        id="landline"
                                                        label="Landline"
                                                        labelHtmlFor="landline"
                                                        required={false}
                                                        value={landline}
                                                        placeholder="Landline"
                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setLandline(e.target.value)}
                                                        error={landlineError}
                                                    />
                                                </div>

                                                {/* Address */}
                                                <div className="col-12 col-xl-6 col-sm-6">
                                                    <TextInput
                                                        id="address"
                                                        label="Address"
                                                        labelHtmlFor="address"
                                                        required={true}
                                                        value={address}
                                                        placeholder="Address"
                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setAddress(e.target.value)}
                                                        error={addressError}
                                                    />
                                                </div>

                                                {/* City */}
                                                <div className="col-12 col-xl-6 col-sm-6">
                                                    <TextInput
                                                        id="city"
                                                        label="City"
                                                        labelHtmlFor="city"
                                                        required={true}
                                                        value={city}
                                                        placeholder="City"
                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCity(e.target.value)}
                                                        error={cityError}
                                                    />
                                                </div>

                                                {/* Post code */}
                                                <div className="col-12 col-xl-6 col-sm-6">
                                                    <TextInput
                                                        id="postCode"
                                                        label="Post code"
                                                        labelHtmlFor="postCode"
                                                        required={true}
                                                        value={postCode}
                                                        placeholder="Post code"
                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPostCode(e.target.value)}
                                                        error={postCodeError}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {/* Edit Project detail */}
                                        <div className={`tab-pane profile_view_tab_panel p-0 fade ${tab === 'project' ? 'show active' : ''}`}
                                            id="project-edit-detail" role="tabpanel" aria-labelledby="project-edit-detail-tab" tabIndex={0}>
                                            {projects && projects?.length > 0 ? (
                                                <React.Fragment>
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <div className=" project_selection_area">
                                                                <div className="row">
                                                                    {projects.map((project) => (
                                                                        <div key={project.id} className="project_selection_container col-11 mx-auto mx-sm-0 col-xxl-4 col-xl-4 col-md-4">
                                                                            <article className={`project_selection p-ripple ${selectedProject?.id === project.id ? 'selected' : ''}`}
                                                                                onClick={() => handleSelectProject(project)}>
                                                                                <h6>{project.projectName}</h6>
                                                                                {isPermissionDelete && <button className="project_delete_btn p-ripple" onClick={() => handleDeleteProjectContact(project.id)}>
                                                                                    <i className="bi bi-trash3"></i>
                                                                                    <Ripple />
                                                                                </button>}
                                                                                <Ripple />
                                                                            </article>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Project name */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <TextInput
                                                                id="projectName"
                                                                label="Project name"
                                                                labelHtmlFor="projectName"
                                                                required={true}
                                                                value={projectName}
                                                                placeholder="Project name"
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setProjectName(e.target.value)}
                                                                error={projectNameError}
                                                            />
                                                        </div>

                                                        {/* Address */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <TextInput
                                                                id="projectAddress"
                                                                label="Address"
                                                                labelHtmlFor="projectAddress"
                                                                required={true}
                                                                value={projectAddress}
                                                                placeholder="Address"
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setProjectAddress(e.target.value)}
                                                                error={projectAddressError}
                                                            />
                                                        </div>

                                                        {/* City */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <TextInput
                                                                id="projectCity"
                                                                label="City"
                                                                labelHtmlFor="projectCity"
                                                                required={true}
                                                                value={projectCity}
                                                                placeholder="City"
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setProjectCity(e.target.value)}
                                                                error={projectCityError}
                                                            />
                                                        </div>

                                                        {/* Post code */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <TextInput
                                                                id="projectPostCode"
                                                                label="Post code"
                                                                labelHtmlFor="projectPostCode"
                                                                required={true}
                                                                value={projectPostCode}
                                                                placeholder="Post code"
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setProjectPostCode(e.target.value)}
                                                                error={projectPostCodeError}
                                                            />
                                                        </div>
                                                    </div>

                                                    <hr className="mt-0 mb-4" />

                                                    <div className="row">
                                                        {/* Company name */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <TextInput
                                                                id="companyName"
                                                                label="Company name"
                                                                labelHtmlFor="companyName"
                                                                required={false}
                                                                value={companyName}
                                                                placeholder="Company name"
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyName(e.target.value)}
                                                                error={companyNameError}
                                                            />
                                                        </div>

                                                        {/* Reg No. */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <TextInput
                                                                id="companyRegNo"
                                                                label="Reg No."
                                                                labelHtmlFor="companyRegNo"
                                                                required={false}
                                                                value={companyRegNo}
                                                                placeholder="Reg No."
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyRegNo(e.target.value)}
                                                                error={companyRegNoError}
                                                            />
                                                        </div>

                                                        {/* Company mail */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <TextInput
                                                                id="companyEmail"
                                                                label="Company mail"
                                                                labelHtmlFor="companyEmail"
                                                                required={false}
                                                                value={companyEmail}
                                                                placeholder="Company mail"
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyEmail(e.target.value)}
                                                                error={companyEmailError}
                                                            />
                                                        </div>

                                                        {/* Mobile */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <TextInput
                                                                id="companyMobile"
                                                                label="Mobile"
                                                                labelHtmlFor="companyMobile"
                                                                required={false}
                                                                value={companyMobile}
                                                                placeholder="Mobile"
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyMobile(e.target.value)}
                                                                error={companyMobileError}
                                                            />
                                                        </div>

                                                        {/* Landline */}
                                                        {/*<div className="col-12 col-xl-6 col-sm-6">
                                                <TextInput
                                                    id="companyLandline"
                                                    label="Landline"
                                                    labelHtmlFor="companyLandline"
                                                    required={false}
                                                    value={companyLandline}
                                                    placeholder="Landline"
                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyLandline(e.target.value)}
                                                    error={companyLandlineError}
                                                />
                                            </div>*/}

                                                        {/* Company address */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <TextInput
                                                                id="companyAddress"
                                                                label="Company address"
                                                                labelHtmlFor="companyAddress"
                                                                required={false}
                                                                value={companyAddress}
                                                                placeholder="Company address"
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyAddress(e.target.value)}
                                                                error={companyAddressError}
                                                            />
                                                        </div>

                                                        {/* City */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <TextInput
                                                                id="companyCity"
                                                                label="City"
                                                                labelHtmlFor="companyCity"
                                                                required={false}
                                                                value={companyCity}
                                                                placeholder="City"
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyCity(e.target.value)}
                                                                error={companyCityError}
                                                            />
                                                        </div>

                                                        {/* Post code */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <TextInput
                                                                id="companyPostCode"
                                                                label="Post code"
                                                                labelHtmlFor="companyPostCode"
                                                                required={false}
                                                                value={companyPostCode}
                                                                placeholder="Post code"
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyPostCode(e.target.value)}
                                                                error={companyPostCodeError}
                                                            />
                                                        </div>
                                                    </div>
                                                </React.Fragment>
                                            ) : (
                                                <div className="contact_no_data">
                                                    <img src="/assets/images/no_data/no_project.png" alt="" />
                                                    <h6>No project data found! Click the Add button to add the project</h6>

                                                    <button className={`add_data_btn p-ripple`} onClick={addProject}>
                                                        <i className={`bi bi-plus-circle`}></i>
                                                        Add Project
                                                        < Ripple />
                                                    </button>
                                                </div>
                                            )}
                                        </div>

                                        {/* Edit Role detail */}
                                        <div className={`tab-pane profile_view_tab_panel p-0 fade ${tab === 'role' ? 'show active' : ''}`}
                                            id="role-edit-detail" role="tabpanel" aria-labelledby="role-edit-detail-tab" tabIndex={0}>
                                            <div className="row">
                                                {/* Role name */}



                                                {/* Role name */}
                                                <div className="col-12 col-xl-6 col-sm-6">
                                                    <DataListModalInput
                                                        key={`role`}
                                                        inputId="role"
                                                        label="Role"
                                                        value={selectedRole}
                                                        displayKey="role_name"
                                                        onAdd={handleShowRoleModal}
                                                        required={true}
                                                        placeHolder="Click to select the role"
                                                        error={selectedRoleError}
                                                    />
                                                </div>


                                                {/* Display role name */}
                                                <div className="col-12 col-xl-6 col-sm-6">
                                                    <TextInput
                                                        id="displayRoleName"
                                                        label="Display role name"
                                                        labelHtmlFor="displayRoleName"
                                                        required={true}
                                                        value={displayRoleName}
                                                        placeholder="Display role name"
                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setDisplayRoleName(e.target.value)}
                                                        error={displayRoleNameError}
                                                    />
                                                </div>

                                                <div className="col-12">
                                                    <div className="form_btn_area justify-content-center">
                                                        {displayRoleCommonError !== '' &&
                                                            <small className="form_error_msg">{displayRoleCommonError}</small>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Dialog>
                {/*  */}

                {/* Project modal */}
                <Dialog header={projectModalHeader} headerClassName="custom_modal_header"
                    footer={projectModalFooter} visible={showProjectModal}
                    className="custom_modal_dialog modal_dialog_lg" onHide={() => { if (!showProjectModal) return; setShowProjectModal(false); }}>
                    <div className="custom_modal_body">
                        <div className="p-sm-3 p-lg-4 pb-lg-0 pb-lg-0 pt-3 pb-0">
                            <div className="row">
                                {/* Project name */}
                                <div className="col-12 col-xl-6 col-sm-6">
                                    <TextInput
                                        id="projectName"
                                        label="Project name"
                                        labelHtmlFor="projectName"
                                        required={true}
                                        value={projectNameNew}
                                        placeholder="Project name"
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setProjectNameNew(e.target.value)}
                                        error={projectNameErrorNew}
                                    />
                                </div>

                                {/* Address */}
                                <div className="col-12 col-xl-6 col-sm-6">
                                    <TextInput
                                        id="projectAddress"
                                        label="Address"
                                        labelHtmlFor="projectAddress"
                                        required={true}
                                        value={projectAddressNew}
                                        placeholder="Address"
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setProjectAddressNew(e.target.value)}
                                        error={projectAddressErrorNew}
                                    />
                                </div>

                                {/* City */}
                                <div className="col-12 col-xl-6 col-sm-6">
                                    <TextInput
                                        id="projectCity"
                                        label="City"
                                        labelHtmlFor="projectCity"
                                        required={true}
                                        value={projectCityNew}
                                        placeholder="City"
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setProjectCityNew(e.target.value)}
                                        error={projectCityErrorNew}
                                    />
                                </div>

                                {/* Post code */}
                                <div className="col-12 col-xl-6 col-sm-6">
                                    <TextInput
                                        id="projectPostCode"
                                        label="Post code"
                                        labelHtmlFor="projectPostCode"
                                        required={true}
                                        value={projectPostCodeNew}
                                        placeholder="Post code"
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setProjectPostCodeNew(e.target.value)}
                                        error={projectPostCodeErrorNew}
                                    />
                                </div>
                            </div>

                            <hr className="mt-0 mb-4" />

                            <div className="row">
                                {/* Company name */}
                                <div className="col-12 col-xl-6 col-sm-6">
                                    <TextInput
                                        id="companyName"
                                        label="Company name"
                                        labelHtmlFor="companyName"
                                        required={false}
                                        value={companyNameNew}
                                        placeholder="Company name"
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyNameNew(e.target.value)}
                                        error={companyNameErrorNew}
                                    />
                                </div>

                                {/* Reg No. */}
                                <div className="col-12 col-xl-6 col-sm-6">
                                    <TextInput
                                        id="companyRegNo"
                                        label="Reg No."
                                        labelHtmlFor="companyRegNo"
                                        required={false}
                                        value={companyRegNoNew}
                                        placeholder="Reg No."
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyRegNoNew(e.target.value)}
                                        error={companyRegNoErrorNew}
                                    />
                                </div>

                                {/* Company mail */}
                                <div className="col-12 col-xl-6 col-sm-6">
                                    <TextInput
                                        id="companyEmail"
                                        label="Company mail"
                                        labelHtmlFor="companyEmail"
                                        required={false}
                                        value={companyEmailNew}
                                        placeholder="Company mail"
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyEmailNew(e.target.value)}
                                        error={companyEmailErrorNew}
                                    />
                                </div>

                                {/* Mobile */}
                                <div className="col-12 col-xl-6 col-sm-6">
                                    <TextInput
                                        id="companyMobile"
                                        label="Mobile"
                                        labelHtmlFor="companyMobile"
                                        required={false}
                                        value={companyMobileNew}
                                        placeholder="Mobile"
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyMobileNew(e.target.value)}
                                        error={companyMobileErrorNew}
                                    />
                                </div>

                                {/* Landline */}
                                {/*<div className="col-12 col-xl-6 col-sm-6">
                                <TextInput
                                    id="companyLandline"
                                    label="Landline"
                                    labelHtmlFor="companyLandline"
                                    required={false}
                                    value={companyLandline}
                                    placeholder="Landline"
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyLandline(e.target.value)}
                                    error=""
                                />
                            </div>*/}

                                {/* Company address */}
                                <div className="col-12 col-xl-6 col-sm-6">
                                    <TextInput
                                        id="companyAddress"
                                        label="Company address"
                                        labelHtmlFor="companyAddress"
                                        required={false}
                                        value={companyAddressNew}
                                        placeholder="Company address"
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyAddressNew(e.target.value)}
                                        error={companyAddressErrorNew}
                                    />
                                </div>

                                {/* City */}
                                <div className="col-12 col-xl-6 col-sm-6">
                                    <TextInput
                                        id="companyCity"
                                        label="City"
                                        labelHtmlFor="companyCity"
                                        required={false}
                                        value={companyCityNew}
                                        placeholder="City"
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyCityNew(e.target.value)}
                                        error={companyCityErrorNew}
                                    />
                                </div>

                                {/* Post code */}
                                <div className="col-12 col-xl-6 col-sm-6">
                                    <TextInput
                                        id="companyPostCode"
                                        label="Post code"
                                        labelHtmlFor="companyPostCode"
                                        required={false}
                                        value={companyPostCodeNew}
                                        placeholder="Post code"
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyPostCodeNew(e.target.value)}
                                        error={companyPostCodeErrorNew}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </Dialog>

                <EmailSearchDialog
                    visible={showSearchComClientEmailModal}
                    contactSubtype="Commercial Client"
                    onHide={() => setShowSearchComClientEmailModal(false)}
                    onEmailConfirm={(email) => onEmailConfirmComClient(email)}
                />

                <RoleSelectionModal
                    isOpen={showRoleSelectionModal}
                    onClose={handleCloseRoleModal}
                    canEdit={true}
                    onSelected={(role: Role) => {
                        setSelectedRole(role);
                        setDisplayRoleName(role?.display_role_name ?? '')
                    }}
                />

                {/*  */}
            </div>
        </React.Fragment>
    )
}

export default ViewCommercialClientContact;